import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText } from '@facet-wealth/design';

export const PoweredByRel = ({ relationship }) => {
  return (
    <FDBodyText
      size="sm"
      align="center"
      value={(
          <>
            {relationship.meta('prompt')}
            &nbsp;
            <img src={relationship.link('related').url()} alt={relationship.meta('alt')} />
          </>
        )}
    />
  );
};

PoweredByRel.defaultProps = {
};

PoweredByRel.propTypes = {
  relationship: PropTypes.object.isRequired,
};
